/**************************************************************************************************************************
 Copyright (c) 2022 WorkEarly Results LLP

     NAME: company-logo.tsx
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 STANDARD IMPORTS
****************************************************************************************************************************/
import { type FunctionComponent } from 'react';

import Assets from '@/constants/assets';
import App from '@/constants/app';
/***************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
****************************************************************************************************************************/
interface CompanyLogoProps {
  vertical?: boolean;
  logoSize?: number;
  titleSize?: number;
  tagLineSize?: number; 
  goto?: string;
}
/***************************************************************************************************************************
 CLASSES / FUNCTIONS
****************************************************************************************************************************/
const Logo: FunctionComponent<CompanyLogoProps> = ({
  vertical = false,
  logoSize = 50,
  titleSize = 30,
  tagLineSize = 13, 
  goto = '/'
}: CompanyLogoProps) => {
  return (
    <a
      className={`w-fit flex ${
        vertical ? 'flex-col gap-5' : 'flex-row gap-3'
      } items-center justify-start cursor-pointer`}
      href={goto}
    >
      <img
        src={Assets.Images.LOGO.src}
        alt={Assets.Images.LOGO.alt}
        width={logoSize}
        height={logoSize}
      />
      <div
        className={`w-fit flex flex-col ${
          !vertical ? 'items-start justify-center' : 'items-center justify-start'
        }`}
      >
        <h2
          className="text-white font-bauhaus font-light uppercase border-b-[1px] border-theme-900 mb-2"
          style={{ fontSize: titleSize }}
        >
          {App.Name}
        </h2>
        <h2
          className="text-theme-900 font-roboto font-medium tracking-widest uppercase"
          style={{ fontSize: tagLineSize }}
        >
          {App.Tagline}
        </h2>
      </div>
    </a>
  );
};

export default Logo;
